import type React from 'react';
import { forwardRef } from 'react';
import { cn } from '@/utils/cn';

type NativeFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> & {
  size?: 'small' | 'medium';
  validationState?: 'invalid';
};

// Thin wrapper for input types Connect TextField doesn't support (number, date, time).
// Delete this and use Connect TextField once it supports these types.
export const NativeField = forwardRef<HTMLInputElement, NativeFieldProps>(
  ({ size = 'medium', validationState, className, ...props }, ref) => (
    <input
      ref={ref}
      aria-invalid={validationState === 'invalid' || undefined}
      className={cn(
        'w-full rounded-100 border-10 border-[var(--ds-color-stroke-default)] bg-core-white text-core-slate-1300 outline-none transition-colors',
        'hover:border-[var(--ds-color-stroke-strong)] focus:border-[var(--ds-color-interactive-primary-enabled)]',
        'disabled:cursor-not-allowed disabled:bg-core-slate-50 disabled:text-core-slate-1100',
        'aria-[invalid=true]:border-core-red-1000',
        size === 'small' && 'h-400 px-100 py-50 text-body-sm',
        size === 'medium' && 'h-500 px-200 py-100 text-body-md',
        className
      )}
      {...props}
    />
  )
);

NativeField.displayName = 'NativeField';
